<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('admin')"/></template>
            <template v-slot:center>
                <div class="sas-head-center">
                    <v-text-field outlined dense v-model="filterObj['query']" @keyup.enter="searchSchoolAdmins"
                                  @input="filterObj.query !== '' ? showIcon = true : showIcon = false"
                                  prepend-inner-icon="mdi-magnify"
                                  :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>
                    <v-btn color="primary" class="text-no-wrap" @click="searchSchoolAdmins" v-text="$t('search')"/>
                </div>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="users" :current-page="currentPage" :page-size="pageSize" :totalPages="totalPages"
                        :total-elements="totalElements" @leftClick="onLeftClick" @rightClick="onRightClick">
                <template v-slot:firstItem>
                    <div class="sas-head-center-block" style="align-items: flex-start">
                        <v-select outlined  dense :items="currentRegions" item-text="title" item-value="id"
                                  :label="$t('region')" v-model="filterObj.regionId" @change="fetchRayonsByRegion"
                                  style="max-width: 276px" @click:append-outer="clearSelect('region')"
                                  :no-data-text="$t('no_data')"
                                  :append-outer-icon="filterObj.regionId !== '' ? 'mdi-close' : ''"/>
                        <v-select outlined  dense :items="filteredRayons" item-text="title"
                                  item-value="id" v-model="filterObj.rayonId" :no-data-text="$t('no_data')"
                                  style="max-width: 276px" :label="$t('district')"
                                  @click:append-outer="clearSelect('rayon')" @change="onSelectRayon"
                                  :append-outer-icon="filterObj.rayonId !== '' ? 'mdi-close' : ''"/>
                        <v-select outlined  dense :items="filteredSchools" item-text="nameRu"
                                  item-value="id" v-model="filterObj.schoolId" :no-data-text="$t('no_data')"
                                  style="max-width: 276px" :label="$t('school')"
                                  :menu-props="{contentClass: 'schoolSelect'}"
                                  @click="addScrollListenerSchoolSelect"
                                  @change="removeSchoolSelectScrollListener"
                                  @blur="removeSchoolSelectScrollListener"
                                  @click:append-outer="filterObj.schoolId=''"
                                  :append-outer-icon="filterObj.schoolId !== '' ? 'mdi-close' : ''"/>
                        <v-btn color="primary" @click="filterSchoolAdmins" v-text="`Фильтр`"/>
                    </div>
                </template>
                <template v-slot:head>
                    <th v-html="$t('full_name')"/>
                    <th v-html="$t('school')"/>
                    <th v-html="$t('district')"/>
                    <th v-html="`Логин`"/>
                    <th/>
                </template>
                <template v-slot:body="{ item }">
                    <td v-html="`${item['surname']} ${item['name']} ${item['middleName']}`"/>
                    <td v-html="item['schoolTitle']"/>
                    <td v-html="item['rayonTitle']"/>
                    <td v-html="item['username']"/>
                    <td>
                        <v-btn icon text color="red" @click="removeSchoolAdmin(item, true)">
                            <v-icon color="red">mdi mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </td>
                </template>
            </SmartTable>
        </div>
        <v-dialog v-model="deleteSchoolAdmin">
            <v-card>
                <v-card-title class="headline" v-html="`Вы действительно хотите удалить?`"/>
                <v-card-text class="headline text-center" v-html="deleteAdmin.name"/>
                <v-card-actions>
                    <v-spacer/>
                    <div class="btn-actions">
                        <v-btn @click="deleteSchoolAdmin = false" color="primary darken-1" v-text="$t('no')"/>
                        <v-btn @click="removeSchoolAdmin('', false)" color="red darken-1" v-text="$t('yes')"/>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import AddSchoolAdmin from '@/components/super-admin/school-admin/AddSchoolAdmin'
import { PersonService } from '@/_services/person.service'
import PreLoader from '@/components/preloader/PreLoader'
import { RayonService } from '@/_services/rayon.service'
import { SchoolService } from '@/_services/school.service'
const personService = new PersonService()
const rayonService = new RayonService()
const schoolService = new SchoolService()

export default {
    name: 'Instructors',
    components: {
        SuperAdminSchoolHead,
        SmartTable,
        AddSchoolAdmin,
        PreLoader
    },
    data: () => ({
        isAddAdmin: false,
        deleteSchoolAdmin: false,
        users: [],
        selectedPerson: {},
        totalPages: 1,
        totalElements: 0,
        pageSize: 0,
        currentPage: 1,
        isLoading: false,
        schoolPage: 0,
        showIcon: false,
        filterObj: {regionId: '', rayonId: '', schoolId: '', query: ''},
        filteredRayons: [],
        filteredSchools: [],
        deleteAdmin: {id: '', name: ''}
    }),
    computed: {
        currentRegions () {
            return this.$store.state.location.regions
        }
    },
    created () {
        this.fetchSchoolAdmins(0)
    },
    methods: {
        onAddAdmin () {
            this.isAddAdmin = true
            this.selectedPerson = {}
        },
        onCloseModal () {
            this.isAddAdmin = false
            this.fetchSchoolAdmins(0)
        },
        fetchSchoolAdmins (page) {
            this.isLoading = true
            personService.listSchoolAdmins(
                this.filterObj.regionId,
                this.filterObj.rayonId,
                this.filterObj.schoolId,
                this.filterObj.query,
                page,
                10
            )
                .then(res => {
                    this.totalElements = res.totalElements
                    this.pageSize = res.pageSize
                    this.totalPages = res.totalPages
                    this.currentPage = res.number + 1
                    if (res.content) {
                        this.users = res.content.map((i, index) => {
                            i.index = index
                            return i
                        })
                    } else this.users = []
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        fetchRayonsByRegion (regionId) {
            this.filteredSchools = []
            this.filterObj.schoolId = ''
            this.filterObj.rayonId = ''
            rayonService.listByRegion(regionId).then((res) => this.filteredRayons = res)
        },
        onSelectRayon () {
            this.filteredSchools = []
            this.schoolPage = 0
            this.filterObj.schoolId = ''
            this.fetchSchoolsByRayon()
        },
        fetchSchoolsByRayon () {
            schoolService.listPageable(this.schoolPage, this.filterObj.regionId, this.filterObj.rayonId)
                .then((res) => {
                    if (res['_embedded']) {
                        res['_embedded']['schoolResourceList'].forEach((school) => {
                            this.filteredSchools.push(school)
                        })
                    } else this.removeSchoolSelectScrollListener()
                })
        },
        addScrollListenerSchoolSelect () {
            this.$nextTick(() => {
                const schoolSelect = document.querySelector('.schoolSelect')
                schoolSelect.addEventListener('scroll', this.innerSelectScrollListener)
            })
        },
        innerSelectScrollListener () {
            const schoolSelect = document.querySelector('.schoolSelect')
            const almostEndOfScroll = (schoolSelect.scrollHeight - schoolSelect.clientHeight) - 100
            if (schoolSelect.scrollTop >= almostEndOfScroll) {
                this.schoolPage++
                this.fetchSchoolsByRayon()
            }
        },
        removeSchoolSelectScrollListener () {
            const schoolSelect = document.querySelector('.schoolSelect')
            if (schoolSelect) {
                schoolSelect.removeEventListener('scroll', this.innerSelectScrollListener)
            }
        },
        filterSchoolAdmins () {
            this.filterObj.query = ''
            this.fetchSchoolAdmins(0)
        },
        onLeftClick () {
            this.currentPage--
            this.fetchSchoolAdmins(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchSchoolAdmins(this.currentPage - 1)
        },
        clearSelect (selectName) {
            if (selectName === 'region') this.clearLocation()
            else {
                this.filterObj.rayonId = ''
                this.filterObj.schoolId = ''
            }
        },
        clearSearch () {
            this.showIcon = false
            this.filterObj.query = ''
            this.searchSchoolAdmins()
        },
        searchSchoolAdmins () {
            this.clearLocation()
            this.fetchSchoolAdmins(0)
        },
        clearLocation () {
            this.filterObj.regionId = ''
            this.filterObj.rayonId = ''
            this.filterObj.schoolId = ''
        },
        onEdit (user) {
            this.isLoading = true
            personService.getById(user.id).then((res) => {
                this.selectedPerson = {
                    id: res.id,
                    name: res.firstName,
                    surname: res.lastName,
                    middleName: res.middleName,
                    dob: res.dateOfBirth,
                    gender: res.gender,
                    email: res.email,
                    phone: res.phone ? res.phone.replace('+', '') : '',
                    address: res.address,
                    schoolId: res.schools[0],
                    pin: res.pin,
                    languageId: res.languageId,
                    userId: res.userId,
                    username: user.username
                }
                this.isAddAdmin = true
                this.isLoading = false
            }).catch((err) => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        removeSchoolAdmin (user, confirm) {
            if (confirm) {
                this.deleteAdmin.id = user.id
                this.deleteAdmin.name = `${user.surname} ${user.name}`
                this.deleteSchoolAdmin = true
            } else {
                this.isLoading = true
                personService.deleteSchoolAdmin(this.deleteAdmin.id).then(() => {
                    this.$toast.success(this.$t('successDeleted'))
                    this.deleteSchoolAdmin = false
                    this.fetchSchoolAdmins(this.currentPage - 1)
                }).catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
            }
        }
    }
}
</script>
